// extracted by mini-css-extract-plugin
module.exports = {"selectProductsList":"AddProductsSidebar_selectProductsList__3AeLI"};